export enum StatefulTabType {
	ENCOUNTERS_ENCOUNTER_TAB = 'ENCOUNTERS_ENCOUNTER_TAB',
	INVOICES_INVOICE_TAB = 'INVOICES_INVOICE_TAB',
	INVOICES_PAYMENT_TAB = 'INVOICES_PAYMENT_TAB',
	ORDERS_ORDER_TAB = 'ORDERS_ORDER_TAB',
	PATIENTS_PATIENT_TAB = 'PATIENTS_PATIENT_TAB',
	PAYMENTS_PAYMENT_TAB = 'PAYMENTS_PAYMENT_TAB',
}
